module.exports = __webpack_public_path__ + "img/ek.b05f71fd.jpg";